import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { Toast } from "primereact/toast";


import { ErrorDialog, ErrorDialogEmpty, ErrorDialogNoAuthorizedSet, ErrorDialogSet, ErrorDialogSetResponse } from "../../dialogs/ErrorDialog";
import { CategoriesService } from "../../service/CategoriesService";

//Components
import { DeleteDialog } from "./DeleteDialog"
import { CategoriesDataTable } from "./CategoriesDataTable";
import { EditDialog } from "./EditDialog";



export const Categories = () => {

    const [stateErrorDialog, setStateErrorDialog] = useState(ErrorDialogEmpty);
    const [loading, setLoading] = useState(true);

    const [category, setCategory] = useState(EMPTY_CATEGORY);
    const [categories, setCategories] = useState(null);

    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);

    const toast = useRef(null);
    const params = useParams();
    const CLU_ID = params.id;
    const EMPTY_CATEGORY = {
        catId:null,
        catName: "",
        cluId: params.id,
    }


    useEffect(() => {
        try {
            const load = async () => {
                setLoading(true);

                const categories = new CategoriesService();
                const res = await categories.getAll(CLU_ID);

                setCategory(EMPTY_CATEGORY);
                setCategories(res);

                setLoading(false);
            };
            load();
        } catch (error) {
            setStateErrorDialog(ErrorDialogNoAuthorizedSet(true, error));
            console.log(error);
        }
    }, []);
    if (loading)
        return (
            <div className="loading-container">
                <h3>Loading...</h3>
            </div>
        );

    const deleteItem =() => {
        const categoriesService = new CategoriesService();            
        return categoriesService.deleteCategory(category.catId);
    }

    const findIndexById = (id,items) => {
        let index = -1;
        for (let i = 0; i < items.length; i++) {
            if (items[i].catId === id) {
                index = i;
                break;
            }
        }
        return index;
    };
    const changeItems = (item) => {
        let _categories = [...categories];
        let index = findIndexById(item.catId, _categories);
        if (index > -1) {
            _categories[index] = item;
            toast.current.show({ severity: "success", summary: "Successful", detail: "Category Updated", life: 3000 });
        } else {
            _categories.push(item);
            toast.current.show({ severity: "success", summary: "Successful", detail: "Category Created", life: 3000 });
        }
        setCategories(_categories);
    }
    const onDeleted = ()=>{
        let _items = categories.filter((val) => val.catId !== category.catId);
        setCategories(_items);
        setCategory(EMPTY_CATEGORY);
        toast.current.show({ severity: "success", summary: "Successful", detail: "Category Deleted", life: 3000 });
    }
    return (
        <div className="p-grid crud-demo">
            <div className="p-col-12">
                <div className="card ">
                    <Toast ref={toast} />

                    <CategoriesDataTable
                        items={ categories }
                        emptyItem={ EMPTY_CATEGORY }
                        openDialog={(row) => {setCategory({ ...row }); setEditDialogVisible(true);}}
                        openDeleteDialog={(rowData) => {setCategory(rowData); setDeleteDialogVisible(true);}}
                    ></CategoriesDataTable>

                    <EditDialog 
                        visible={editDialogVisible} 
                        item={category}
                        onChange={changeItems}
                        hideDialog={() => setEditDialogVisible(false)}
                        setStateErrorDialog={setStateErrorDialog}                        
                    />

                    <DeleteDialog 
                    visible={deleteDialogVisible} 
                        item={{id: category.catId, name: category.catName}} 
                        header="Delete category" 

                        hideDialog={() => setDeleteDialogVisible(false)}
                        deleteItem={deleteItem}
                        onDeleted={onDeleted}
                        setStateErrorDialog={setStateErrorDialog}
                    />

                    <ErrorDialog stateDialog={stateErrorDialog}></ErrorDialog>
                </div>
            </div>
        </div>
    );
};
